import type { UUID } from 'interfaces';

export const citationKeys = {
  all: ['citation'] as const,
  detail: (id: string) => [...citationKeys.all, id] as const,
};

export const messageAttachmentKeys = {
  all: ['messageAttachment'] as const,
  detail: (messageId: string, attachmentId: string) =>
    [...messageAttachmentKeys.all, messageId, attachmentId] as const,
};

export const aiAssistantDetailsKeys = {
  all: ['aiAssistantDetails'] as const,
  detail: (id: string) => [...aiAssistantDetailsKeys.all, id] as const,
};

export const aiAssistantMembershipKeys = {
  all: ['aiAssistantMembership'] as const,
  detail: (id: string) => [...aiAssistantMembershipKeys.all, id] as const,
};

export const aiFallbackAssessmentCreationKeys = {
  all: ['aiFallbackAssessmentCreation'] as const,
  detail: (id: string) =>
    [...aiFallbackAssessmentCreationKeys.all, id] as const,
};

export const aiSourcesKeys = {
  all: ['aiSources'] as const,
  list: (assistantId: UUID) => [...aiSourcesKeys.all, assistantId] as const,
  detail: (assistantId: UUID, sourceId: UUID) =>
    [...aiSourcesKeys.list(assistantId), sourceId] as const,
};
